// Images
import cover from "../images/cover.jpg";
import streetcultback from "../images/street-culture-back.jpg";
import verbumproject from "../images/verbum-project-image.png";
import verbumhistory from "../images/verbum-history-img.jpg";
import verbumcard from "../images/verbum-test-card.jpg";
import aneteprojects from "../images/aneteprojects.jpg";
import anetelanding from "../images/anetelanding.jpg";
import portfolioview from "../images/portfolio-project-image.jpg";
import portfolioskills from "../images/portfolio_skills.jpg";
import trackeaseitem from "../images/trackease-item.png";
import trackeasehome from "../images/trackease-home.png";
import boomboxhome from "../images/boombox-home.png";
import boomboxhsongs from "../images/boombox-songs.png";
import studlylanding from "../images/studly-landing.png";
import studlyfooter from "../images/studly-footer.png";
import ewgarticles from "../images/ewg-articles.png";
import ewgdonate from "../images/ewg-donate.png";
import mercyalbum from "../images/mercy-album.png";
import brandingtypograpgy from "../images/branding-typography.png";
import brandinglogos from "../images/branding-logos.png";
import mercyposter from "../images/mercy-poster.png";
import arrow from "../images/arrow_svg.svg";
import arrowdiag from "../images/arrow_diag_svg.svg";

// Videos
import streetcultvideo from "../images/street_culture_video.mp4";
import aneteportvideo from "../images/anete_portfolio_video.mp4";
import portfoliovido from "../images/portfolio_video.mp4";
import trackeasevideo from "../images/trackease-video.mp4";
import boomboxvideo from "../images/boombox-video.mp4";
import studylvideo from "../images/studly-video.mp4";
import ewgvideo from "../images/ewg-video.mp4";
import motionvideoshort from "../images/motion-video-short.mp4";
import brandingvideo from "../images/branding-video.mp4";

export const media = {
  cover,
  streetcultback,
  streetcultvideo,
  verbumproject,
  verbumhistory,
  verbumcard,
  aneteportvideo,
  aneteprojects,
  anetelanding,
  portfoliovido,
  portfolioview,
  portfolioskills,
  trackeaseitem,
  trackeasevideo,
  trackeasehome,
  boomboxhome,
  boomboxhsongs,
  boomboxvideo,
  studlylanding,
  studylvideo,
  studlyfooter,
  ewgarticles,
  ewgvideo,
  ewgdonate,
  mercyalbum,
  motionvideoshort,
  brandingvideo,
  brandingtypograpgy,
  brandinglogos,
  mercyposter,
  arrow,
  arrowdiag,
};
